import React from 'react';

export default () => (
  <div style={{display: 'flex', height: '100%', minHeight: 300, width: '100%', justifyContent: 'center', alignItems: 'center'}}>
    <p>Loading</p>
  </div>
);
